import React, { useState, useEffect, useContext } from 'react';
import { Form } from 'react-bootstrap';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { useLocation } from "react-router-dom";
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import { AuthContext } from '../context/AuthContext';

const UpdateName = ({ open, onClose, onUpdate, currentname }) => {
    const location = useLocation();
    const initialName = location.state?.name || currentname || '';
    const [name, setName] = useState(initialName);
    const [errors, setErrors] = useState({ name: '' });
    const [loading, setLoading] = useState(false);
    const { updateUserData } = useContext(AuthContext);

    useEffect(() => {
        // Update `name` state whenever `currentname` prop changes
        if (currentname) {
            setName(currentname);
        }
    }, [currentname]);

    const handleNameSubmit = async (event) => {
        event.preventDefault();

        let newErrors = { ...errors };

        if (!name) {
            console.log('no email');
            newErrors.name = 'Name is required.';
        } else {
            newErrors.name = '';
        }

        setErrors(newErrors);

        // If there are no errors, close the dialog
        if (!newErrors.name) {
            setLoading(true);

            try {
                await updateUserData('name', name); 
                onClose(); // Close the dialog on success
                onUpdate("name", name); 

            } catch (error) {
                console.error("Error updating name:", error);
                // Handle error if needed
            } finally {
                setLoading(false);
            }
        }
    };

    return(
        <Dialog open={open} onClose={onClose} aria-labelledby="settings-dialog-title" fullWidth PaperProps={{
            style: {
              width: '480px',
              maxWidth: '100%',
            },
          }} className="setting-dialog">
            <DialogTitle id="settings-dialog-title" className="d-flex justify-content-between mb-4">
                <div className="d-flex align-items-center">
                    <img style={{ float: 'none', height: "20px", width: "18px" }} src={`${process.env.PUBLIC_URL}/images/left.svg`} alt="left" className="close-icon" role="button" 
                    onClick={() => {
                        onClose();
                    }} />
                    <span style={{marginLeft:"10px"}}>Update Name</span>
                </div>
              <img style={{ float: 'none', height: "22px", width: "20px" }} src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={onClose} />
            </DialogTitle>
            <DialogContent>
                <Form onSubmit={handleNameSubmit}>
                    <div className="mb-2">
                        <span style={{fontSize: "16px"}}>Name</span>
                    </div>
                    <Form.Group controlId="formBasicEmail" className="control">
                        <FormControl className="square-form-control-update m-0" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                placeholder=" "
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                fullWidth
                                margin="normal"
                                type="text"
                            />
                        </FormControl>
                    </Form.Group>
                    {errors.name && <div className="text-danger mt-1">{errors.name}</div>}
                    
                    <div className="mt-2 mb-3 row justify-content-center">
                        <Button variant="primary" type="submit" style={{backgroundColor: '#317CFF', textTransform: 'none'}} className="mt-5 w-55 p-2 theme-btn-email" disabled={loading}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </Button>
                    </div>
                </Form>
            </DialogContent>
        </Dialog>
    );
};

export default UpdateName;